<div class="flex flex-column">
	<div class="flex input-ctr">
		<app-input
			class="w-full"
			type="text"
			label="Nome:"
			id="name"
			placeholder=""
			[(value)]="name"
		/>
	</div>

	<div class="flex input-ctr">
		<app-input
			class="w-full"
			type="text"
			label="E-mail:"
			id="email"
			[(value)]="email"
		/>
	</div>

	<div class="flex input-ctr">
		<app-text
			class="w-full"
			type="text"
			label="Mensagem:"
			id="message"
			placeholder=""
			[(value)]="message"
		/>
	</div>

	<div class="flex btn-ctr" *ngIf="!contactSent">
		<app-button
			caption="Enviar"
			icon="fa fa-envelope"
			class="w-full"
			[loading]="loading"
			[disabled]="loading"
			(action)="send()"
		/>
	</div>
	<div class="flex sent-msg flex-column" *ngIf="contactSent">
		<b>Mensagem enviada!</b>
		<span>O coveiro de plantão vai analisar a sua mensagem.</span>
	</div>
</div>
